var $wc = jQuery.noConflict();

$wc(document).ready(function(){
  var data_value = [], wc_error = '', slide_effect = [], slide_effect_in, effect_effect_out, mainImage = '';
  var shop_url = $wc('#shop_url_id').text();
  var shop_money_format = $wc('#shop_price_format').text();
    
  var wc_ajax_onError = function(error, message){
    var data = eval('('+error.responseText+')');
    if(!!data.message){
      $wc('.quickview_error_cls p').text(data.message+'('+data.status+') : '+data.description);
      $wc('.quickview_error_cls').show();
    }
  };

  var wc_ajax_addItemFromForm = function(form_id, variant_id, callback){
    $wc('.quickview_added_product_cls').hide();
    $wc('.quickview_error_cls p').empty();
    $wc('.quickview_error_cls').hide();
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == 'add_to_cart_form'){
          $wc('#'+form_id).find('.addtocartqv').html($wc('.quickViewModal_info .button_wait').html());
        }
      },
      data: $wc('#'+form_id).serialize(),
      dataType: 'json',
      success: function(line_item){
        $wc('#'+form_id).find('.addtocartqv').html($wc('.quickViewModal_info .button_added').html());
        setTimeout(function(){
          $wc('#'+form_id).find('.addtocartqv').html($wc('.quickViewModal_info .button').html());
        }, 2000);
        $wc('.quickview_added_product_cls').show('300');
        setTimeout(function(){
          $wc.getJSON('/cart.js', function(cart){
            if(data_value.cart_count_class != ''){
              var cart_class = data_value.cart_count_class;
              cart_class.replace('.', '');
              $wc('.'+cart_class).html(cart.item_count);
            }
          });
        },300);
      },
      error: function(XMLHttpRequest, textStatus){
        if(form_id != 'add_to_cart_form'){
          wc_ajax_onError(XMLHttpRequest, textStatus);
        } else{
          wc_ajax_onError(XMLHttpRequest, textStatus);
          $wc('#'+form_id).find('.addtocartqv').html($wc('.quickViewModal_info .button_error').html());
          setTimeout(function(){
            $wc('#'+form_id).find('.addtocartqv').html($wc('.quickViewModal_info .button').html());
          }, 2000);
        }
      }
    };
    $wc.ajax(params);
  };

  $wc('#add_to_cart_btn_id').click(function(evt){
    evt.preventDefault();
    wc_ajax_addItemFromForm($wc(this).closest('form').attr('id'), $wc(this).attr('id'));
  });
  
  var showbutton_code = function(){
    var main_div_id = $wc('.quickview_button_cls_main').closest('div');
    main_div_id.css({'position':'relative'});
    main_div_id.mouseover(function(){
      $wc(this).find('.quickview_button_cls_main').show();
    });
    main_div_id.mouseout(function(){
      $wc(this).find('.quickview_button_cls_main').hide();
    });
    main_div_id.bind('touchstart', function(){
      $wc(this).find('.quickview_button_cls_main').show();
    });
    main_div_id.bind('touchend', function(){
      setTimeout(function(){
        $wc(main_div_id).find('.quickview_button_cls_main').hide();
      }, 2000);
    });
  };
  
  function wc_real_visitors(value){
    var ct_code = '';
    ct_code += '<div class="wc_real_time_visitor"><p class="wc_counter_p"><span class="wc_counter_count">288</span><span class="wc_counter_text"> '+value.text+'</span></p></div>';
    $wc('#wc_real_time_visitor_id').html(ct_code);
    
    var min_visitor = value.minval, max_visitor = value.maxval;
    min_visitor = Math.ceil(min_visitor);
    max_visitor = Math.floor(max_visitor);
    var random_number = Math.floor(Math.random() * (max_visitor - min_visitor + 1)) + min_visitor;
    var mytimeAgo = ['1', '2', '3', '4', '5', '8', '10', '-1', '-2', '-3', '-4', '-5', '-7', '-9'];
    var plus = ['10', '20', '15'];
    var randomlytimeAgo = '', currentmytimeAgo = '', range = '';
    setInterval(function(){
      randomlytimeAgo = Math.floor(Math.random() * mytimeAgo.length);
      currentmytimeAgo = mytimeAgo[randomlytimeAgo];
      random_number = parseInt(random_number) + parseInt(currentmytimeAgo);
      if(random_number <= 10){
        range = Math.floor(Math.random() * plus.length);
        var final = plus[range];
        random_number = random_number + final;
      }
      if(random_number > 500){
        range =  Math.floor(Math.random() * plus.length);
        var final = plus[range];
        random_number = random_number - final;
      }
      $wc('.wc_counter_count').html(random_number);
    }, 2000);
  }
  
  function changePriceValue(cell, value){
    var temp_price = Shopify.formatMoney(value, shop_money_format);
    $wc(cell).html('<span class="money">'+temp_price+'</span>');
  }
  
  function wc_load_slider(class_val){
    $wc(class_val).slick({
      dots: false,
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
  
  function wc_set_promobar(data_value){
    var promobar_code = '';
    promobar_code += '<div class="wc_quickview_promo_bar"><ul class="wc_qv_pb_ul">';
    $wc.each(data_value.promobar.bar, function(index, promo){
      promobar_code += '<li class="wc_qv_pb_li"><p class="wc_promo_bar_p"><span class="wc_promo_bar_span">'+promo.text+'</span><a href="'+promo.btn_link+'" class="wc_promobar_button">'+promo.btn_text+'</a></p></li>';
    });
    promobar_code += '</ul></div>';
    if(data_value.promobar.promobar_show == 'true'){
      $wc('#wc_quickview_promo_bar_id').html(promobar_code);
    }
    if(data_value.promobar.global_quickpop == 'true'){
      if($wc('#wc_trust_badge_global_id').length > 0){
        $wc('#wc_promobar_global_id').html(promobar_code);
      } else{
        $wc('body').prepend('<div id="wc_promobar_global_id">'+promobar_code+'</div>');
      }
      wc_load_slider('#wc_promobar_global_id .wc_qv_pb_ul');
      var promo_height = $wc('#wc_promobar_global_id').outerHeight();
      $wc('body').attr('style', 'padding-top:'+promo_height+'px !important;');
    }
  }
  
  function wc_trust_badge(value){
    var trust_badge_code = '';
    trust_badge_code += '<div class="quickview_secure_icon"><ul class="quickview_secure_icon_ul quickview_secure_icon_5">';
    $wc.each(value.icon, function(index, icon){
      trust_badge_code += '<li class="quickview_secure_icon_li"><em class="pf '+icon+'"></em></li>';
    });
    trust_badge_code += '</ul></div>';
    if(data_value.trust_badge.show_trust_badge == 'true'){
      $wc('#quickview_secure_icon_id').html(trust_badge_code);
    }
    
    if(data_value.trust_badge.show_whole_site == 'true'){
      var wc_page_url = window.location.href;
      if(wc_page_url.indexOf('/products/') > -1){
        if($wc('#wc_trust_badge_global_id').length > 0){
          $wc('#wc_trust_badge_global_id').html(trust_badge_code);
        } else{
          $wc('<div id="wc_trust_badge_global_id">'+trust_badge_code+'</div>').insertAfter('form[action="/cart/add"]');
        }
      }
    }
  }

  function ajax_success(data_value){
    if(wc_error != 'ajax_error'){
      if(data_value.promobar.global_quickpop == 'true' || data_value.promobar.promobar_show == 'true'){
        wc_set_promobar(data_value);
      }
      if(data_value.trust_badge.show_trust_badge == 'true' || data_value.trust_badge.show_whole_site == 'true'){
        wc_trust_badge(data_value.trust_badge);
      }
      if(data_value.realtime_visitor.show == 'true'){
        wc_real_visitors(data_value.realtime_visitor);
      }
    }
    
    open_quickview = function(product_handle){
      $wc('#product_quickview_id').show();
      $wc('.quickview_outer_padding_cls').addClass('animated '+slide_effect_in);
      if(data_value.error == true){
        $wc('#product_quickview_id .quickview_button_cls_main').remove();
      } else{
        if(wc_error != 'ajax_error'){
          $wc('#product_quickview_id .custom_6_col_cls').hide();
          $wc('#product_quickview_id .wc_quickview_promo_bar').hide();
          $wc('.loader_img_cls').show();
          setTimeout(function(){
            Shopify.getProduct(product_handle);
          }, 100);
        } else{
          $wc('#product_quickview_id .quickview_button_cls_main').remove();
        }
      }
      if(data_value.status == 'accepted' || data_value.status == 'active'){
        $wc('.company_name_cls').remove();
      }
    }
    Shopify.onProduct = function(product){
      var _parent = '#product_quickview_id';
      $wc('.quickview_fullinfo').attr('href', product.url);
      $wc(_parent+' .product_title a').text(product.title);
      $wc(_parent+' .product_title a').attr('href', product.url);
      $wc(_parent+' .wc_product_rating_cls').empty();
      $wc(_parent+' .wc_product_rating_cls').append("<span class=\"shopify-product-reviews-badge\" data-id=\""+product.id+"\"></span>");
      $wc(_parent+' .quickview_social_sharing .facebook_share_url').attr('href', '//www.facebook.com/sharer.php?u='+shop_url+product.url);
      $wc(_parent+' .quickview_social_sharing .twitter_share_url').attr('href', '//twitter.com/share?text='+product.title+'&amp;url='+shop_url+product.url);
      $wc(_parent+' .quickview_social_sharing .pinterest_share_url').attr('href', '//pinterest.com/pin/create/button/?url='+shop_url+product.url+'&amp;media='+product.featured_image+'&amp;description='+product.featured_image);
      $wc(_parent+' .quickview_social_sharing .google_share_url').attr('href', '//plus.google.com/share?url='+shop_url+product.url);

      var variant = '';
      for(var i=0; i<product.variants.length; i++){
        if(product.variants[i].inventory_quantity > 0){
          variant = product.variants[i];
          break;
        }
      }

      if(variant){
        for(var i=0; i<product.variants.length; i++){
          if(product.variants[i].inventory_policy == "continue"){
            variant = product.variants[i];
            break;
          }
        }
      } else{
        variant = product.variants[0];
      }

      mainImage = product.featured_image;
      var shopifyimgurl = variant.featured_image ? variant.featured_image.src : product.featured_image;
      var imgurl = "<img class=\"full-width\" id=\"quickview_img_zoom\" alt=\"\" src = \""+Shopify.resizeImage(shopifyimgurl, 'large')+"\" data-zoom-image=\""+Shopify.resizeImage(shopifyimgurl, 'original')+"\" >";
      $wc(_parent+' .quickview_large_img_ul .product_main_img_cls').empty();
      $wc(_parent+' .quickview_large_img_ul .product_main_img_cls').append(imgurl);

      var poplet_imgs = '';
      if(product.images.length > 1){
        for(var i=0; i<product.images.length; i++){
          var temp_img = product.images[i];
          poplet_imgs += '<li><figure class="product_poplet_imgs"><img src="'+Shopify.resizeImage(temp_img, 'large')+'" data-zoom-image="'+Shopify.resizeImage(temp_img, 'original')+'"></figure></li>';
        }
      }

      var total_pop_imgs = '';
      total_pop_imgs = poplet_imgs;
      $wc(_parent+' .slider-nav.poplet').empty();
      $wc(_parent+' .slider-nav.poplet').append(total_pop_imgs);

      $wc('#product_quickview_id .product_poplet_imgs').on('click', function(e){
        var img_url = $wc(this).find('img').attr('src');
        var zoom_img_src = $wc(this).find('img').attr('data-zoom-image');
        $wc('#product_quickview_id .quickview_large_img_ul').find('figure img').attr('src', img_url);
        $wc('#product_quickview_id .quickview_large_img_ul').find('figure img').attr('data-zoom-image', zoom_img_src);
        if(data_value.enable_imgzoom == '1'){
          $wc('.zoomContainer').remove();
          $wc('#quickview_img_zoom').removeData('elevateZoom');
          $wc('#quickview_img_zoom').removeData('zoomImage');
          if($wc(window).width() > 768){
            $wc('#quickview_img_zoom').elevateZoom({scrollZoom:true});
          }
        }
      });

      var desc = product.description;
      $wc(_parent+' .product-info__description').show();
      $wc(_parent+' .product-info__description').html(desc);

      var inv_qua = variant.inventory_quantity;
      if(variant.price < variant.compare_at_price){
        $wc('.price-part .main').addClass('price-box__old');
        $wc('.price-part .price-box__new').show();
        changePriceValue('.price-part .main', variant.compare_at_price);
        changePriceValue('.price-part .price-box__new', variant.price);
      } else{
        $wc('.price-part .price-box__new').hide();
        $wc('.price-part .main').removeClass('price-box__old');
        changePriceValue('.price-part .main', variant.price);
      }

      if(product.variants.length > 1){
        var variants_margin = product.options.length == 2 ? 'variants_margin' : '';
        var select = '<select id="product-select-wc" name="id">';
        var selected = 'selected';
        for(var i=0; i<product.variants.length; i++){
          var _var = product.variants[i];
          if(_var.available){
            select += '<option value="'+_var.id+'"'+selected+'>'+_var.title+' - '+Shopify.formatMoney(_var.price, shop_money_format)+'</option>'
            selected = '';
          }
        }
        select += '</select>';
        var variant_select = '<div class="variants_selects ' + variants_margin + '">';
        variant_select += select;
        variant_select += '</div><div class="divider divider--sm"></div>';
        select = variant_select;
      } else{
        var select = '<input type="hidden" name="id" value="'+product.variants[0].id+'" />';
      }
      $wc('.variants').empty();
      $wc('.variants').html(select);

      var out_of_stock = false;
      if(product.available){
      } else{
        out_of_stock = true;
      }

      if(!out_of_stock){
        $wc('.product-available').show();
        $wc('.product-disable').hide();
        $wc('.addtocartqv').attr('id', product.id);
      } else{
        $wc('.product-available').hide();
        $wc('.product-disable').show();
      }

      if(product.available && product.variants.length > 1){
        new Shopify.OptionSelectors('product-select-wc', {product:product, onVariantSelected:wc_selectCallbackQv, enableHistoryState:false});
        if($wc('#product_quickview_id .variants_selects .selector-wrapper').length > 0) {
          $wc.each($wc('#product_quickview_id .variants_selects .selector-wrapper'), function(index){
            $wc(this).find('label').text(product.options[index].name);
          });
        }
      } else{
        $wc('.currency .active').trigger('click');
      }

      selectGrid(_parent, product);
      if($wc('.spr-badge').length > 0){
        $wc.getScript(window.location.protocol + '//productreviews.shopifycdn.com/assets/v4/spr.js');
      }

      if($wc('.selector-wrapper label').length){
        $wc('.selector-wrapper label').each(function(index){
          $wc(this).text($wc(this).text());
        });
      }

      var main_img_url = Shopify.resizeImage(shopifyimgurl, 'large');
      $wc('#quickview_img_zoom').attr('src', main_img_url).on('load', function(){
        $wc('.loader_img_cls').hide();
        $wc('#product_quickview_id .custom_6_col_cls').show();
        $wc('#product_quickview_id .wc_quickview_promo_bar').show();
        wc_load_slider('#wc_quickview_promo_bar_id .wc_qv_pb_ul');
        $wc('.quickview_outer_padding_cls').removeClass('animated '+slide_effect_in);
		var figure_height = [];
		$wc('.quickview_product_main_img .quickview_poplet_img_ul li').each(function(){
		  var temp_cls = $wc(this).find('figure');
		  var temp_width = parseInt(temp_cls.outerHeight());
		  figure_height.push(temp_width);
		});
		var max_width = Math.max.apply(Math, figure_height);
		$wc('.quickview_product_main_img .quickview_poplet_img_ul li figure').css('height', max_width+'px');
      });

      if(data_value.enable_imgzoom == '1'){
        if($wc(window).width() > 768){
          $wc('#quickview_img_zoom').elevateZoom({scrollZoom:true});
        }
      }
      
      if(!('ontouchstart' in window) && !navigator.msMaxTouchPoints && !navigator.userAgent.toLowerCase().match(/windows phone os 7/i)){
        return false;
      }
    }

    $wc('.quickview_fullinfo').bind('click', function(){
      window.location.href = $wc(this).attr('href');
    });
  }

  var wc_selectCallbackQv = function(variant, selector){
    var _parent = '#product_quickview_id';
    var _parentprice = _parent + ' .price-part';
    if(!variant){
      $wc(_parent+' .price-box').hide();
      $wc(_parent+' .qwt').hide();
      $wc(_parent+' .control-console').hide();
      $wc(_parent+' .addtocartqv').attr('disabled','disabled');
      $wc(_parent+' .addtocartqv').text('Unavailable');
      return false;
    }

    $wc(_parent + ' .price-box').show();
    $wc(_parent + ' .qwt').show();
    $wc(_parent + ' .control-console').show();

    if(variant.price < variant.compare_at_price){
      $wc(_parentprice+' .main').addClass('price-box__old');
      $wc(_parentprice+' .price-box__new').show();
      changePriceValue(_parentprice+' .main', variant.compare_at_price);
      changePriceValue(_parentprice+' .price-box__new', variant.price);
    } else{
      $wc(_parentprice+' .price-box__new').hide();
      $wc(_parentprice+' .main').removeClass('price-box__old');
      changePriceValue(_parentprice+' .main', variant.price);
    }

    $wc('.loader_img_cls').show();
    var shopifyimgurl = variant.featured_image ? variant.featured_image.src : mainImage;
    var imgurl = "<img class=\"full-width\" id=\"quickview_img_zoom\" alt=\"\" src =\""+shopifyimgurl+"\" data-zoom-image=\""+Shopify.resizeImage(shopifyimgurl, 'original')+"\" >";
    if($wc(_parent+' .quickview_large_img_ul .product_main_img_cls').children().length > 0){
      var detach = $wc(_parent+' .quickview_large_img_ul .product_main_img_cls img').detach();
    }
    $wc(_parent+' .quickview_large_img_ul .product_main_img_cls').empty();
    $wc(_parent+' .quickview_large_img_ul .product_main_img_cls').append(imgurl);

    if(variant && variant.available){
      $wc(_parent + ' .addtocartqv').removeAttr('disabled');
      var add_to_Cart_text = $wc('.quickViewModal_info .button').text();
      $wc(_parent + ' .addtocartqv').html(add_to_Cart_text);
      $wc(_parent + ' .control-console').show();
    } else{
      $wc(_parent + ' .addtocartqv').attr('disabled','disabled');
      $wc(_parent + ' .addtocartqv').text('Unavailable');
      $wc(_parent + ' .control-console').hide();
    }

    var main_img_url = Shopify.resizeImage(shopifyimgurl, 'large');
    $wc('#quickview_img_zoom').attr('src', main_img_url).on('load', function(){
      $wc('.loader_img_cls').hide();
      if(data_value.enable_imgzoom == '1'){
        $wc('.zoomContainer').remove();
        $wc('#quickview_img_zoom').removeData('elevateZoom');
        $wc('#quickview_img_zoom').removeData('zoomImage');
        if($wc(window).width() > 768){
          $wc('#quickview_img_zoom').elevateZoom({scrollZoom:true});
        }
      }
    });

    $wc('.currency .active').trigger('click');
  };

  function selectGrid(_parent, product){
    var select_wapper_length = $wc(_parent + " .selector-wrapper").length;
    function timeout(){
      if($wc(_parent+' .selector-wrapper').length >= 2){
        $wc(_parent+' .selector-wrapper').addClass('custom_6_col_cls');
        $wc(_parent+' .single-option-selector').addClass('select--wd');
      } else{
        $wc(_parent+' .selector-wrapper').addClass('custom_12_col_cls');
        $wc(_parent+' .single-option-selector').before('<label class="label_text_cls">'+product.options[0].name+'</label>');
        $wc(_parent+' .variants_selects .selector-wrapper').find('label').not('.label_text_cls').remove();
        $wc(_parent+' .single-option-selector').addClass('select--wd');
      }
    }
    setTimeout(timeout, 5);
  }
  
  var ajax_shop_url = $wc('#shop_url_id').text();
  ajax_shop_url = ajax_shop_url.replace(/^https?\:\/\//i, '');

  $wc.ajax({
    url: 'https://thimatic-apps.com/quickview/get_data.php',
    type: 'post',
    dataType: 'json',
    data: {shop : ajax_shop_url},
    success: function(result){
      data_value = result;
      if(data_value.error == true){
        $wc('.quickview_button_cls_main').remove();
      } else{
        if(data_value.enable_quickview != '1'){
          $wc('.quickview_button_cls_main').remove();
        }
        $wc('.quickview_outer_padding_cls').css({'max-width':data_value.main_width});
        slide_effect = data_value.effects;
        if(slide_effect.indexOf("/") >= 0){
          slide_effect = slide_effect.split('/');
          slide_effect_in = slide_effect[0];
          effect_effect_out = slide_effect[1];
        } else{
          slide_effect_in = slide_effect;
          effect_effect_out = slide_effect;
        }
        
        var css_changes = '';
        css_changes += '<style type="text/css">';
        css_changes += '.quickview_product_main_img .quickview_poplet_img_ul li figure{border:1px dotted #'+data_value.color.box.border+'}';
        css_changes += '.quickview_product_main_img .quickview_large_img_ul .product_main_img_cls{border:1px dotted #'+data_value.color.box.border+'}';
        css_changes += '.quickview_product_desc_cls .main span, .quickview_product_desc_cls .main, .quickview_product_desc_cls .price-box__old span, .quickview_product_desc_cls .price-box__old, .quickview_product_desc_cls .price-box__new span, .quickview_product_desc_cls .price-box__new{color:#'+data_value.color.price_color+'}';
        css_changes += '.quickview_product_desc_cls .quickview_add_to_cart_btn{background:#'+data_value.color.button.addcart_bg+'; color:#'+data_value.color.button.addcart_txt+';}';
        css_changes += '.quickview_product_desc_cls .quickview_add_to_cart_btn:hover, .quickview_product_desc_cls .quickview_add_to_cart_btn:focus{background:#'+data_value.color.button.addcart_bg_hover+'; color:#'+data_value.color.button.addcart_txt_hover+';}';
        css_changes += '.quickview_product_desc_cls .quickview_fullinfo{background:#'+data_value.color.button.view_bg+'; color:#'+data_value.color.button.view_txt+';}';
        css_changes += '.quickview_product_desc_cls .quickview_fullinfo:hover, .quickview_product_desc_cls .quickview_fullinfo:focus{background:#'+data_value.color.button.view_bg_hover+'; color:#'+data_value.color.button.view_txt_hover+';}';
        css_changes += '.quickview_product_desc_cls .quickview_unavialable_btn{background:#'+data_value.color.button.view_bg+'; color:#'+data_value.color.button.view_txt+';}';
        css_changes += '.quickview_product_desc_cls .product_title a{color:#'+data_value.color.product_name+';}';
        css_changes += '.quickview_product_desc_cls .product_title a:hover{color:#'+data_value.color.product_name_hover+';}';
        css_changes += '.quickview_social_sharing ul li.social_app_icon{border:1px solid #'+data_value.color.social+';}';
        css_changes += '.social_app_icon a, .social_app_icon a em{color:#'+data_value.color.social+';}';
        css_changes += '.quickview_social_sharing ul li.social_app_icon:hover{border:1px solid #'+data_value.color.social_hover+';}';
        css_changes += '.social_app_icon a:hover, .social_app_icon a em:hover{color:#'+data_value.color.social_hover+';}';
        css_changes += '.wc_quickview_promo_bar{background-color:#'+data_value.promobar.text.bg_color+';}';
        css_changes += '#wc_promobar_global_id .wc_quickview_promo_bar{background-color:#'+data_value.promobar.text.bg_color+'; box-shadow:0px 2px 1px 0px #'+data_value.promobar.text.bg_color+'99}';
        css_changes += '.quickview_secure_icon .quickview_secure_icon_ul .quickview_secure_icon_li em{color:#'+data_value.trust_badge.icon_color+'; font-size:'+data_value.trust_badge.icon_fontsize+'px;}';
        
        if(data_value.font.body.font_family_full != 'Defualt'){
          $wc('head').append('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family='+data_value.font.body.font_family+':300,400,500,600,700" type="text/css" />');
          css_changes += '#product_quickview_id p, #product_quickview_id span{font-family:'+data_value.font.body.font_family_full+';}';
          css_changes += '.quickview_product_desc div, .quickview_product_desc li, .quickview_product_desc p, .quickview_product_desc span{font-family:'+data_value.font.body.font_family_full+' !important; font-size:'+data_value.font.body.font_size+'px; line-height:'+data_value.font.body.line_height+'px;}';
        } else{
          css_changes += '.quickview_product_desc div, .quickview_product_desc li, .quickview_product_desc p, .quickview_product_desc span{font-size:'+data_value.font.body.font_size+'px; line-height:'+data_value.font.body.line_height+'px;}';
        }
        if(data_value.font.head.font_family_full != 'Defualt'){
          $wc('head').append('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family='+data_value.font.head.font_family+':300,400,500,600,700" type="text/css" />');
          css_changes += '.quickview_product_desc_cls .product_title a{font-family:'+data_value.font.head.font_family_full+'; font-size:'+data_value.font.head.font_size+'px; line-height:'+data_value.font.head.line_height+'px;}';
        } else{
          css_changes += '.quickview_product_desc_cls .product_title a{font-size:'+data_value.font.head.font_size+'px; line-height:'+data_value.font.head.line_height+'px;}';
        }
        if(data_value.font.price.font_family_full != 'Defualt'){
          $wc('head').append('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family='+data_value.font.price.font_family+':300,400,500,600,700" type="text/css" />');
          css_changes += '.quickview_product_desc_cls .price-box span{font-family:'+data_value.font.price.font_family_full+'; font-size:'+data_value.font.price.font_size+'px; line-height:'+data_value.font.price.line_height+'px;}';
        } else{
          css_changes += '.quickview_product_desc_cls .price-box span{font-size:'+data_value.font.price.font_size+'px; line-height:'+data_value.font.price.line_height+'px;}';
        }
        if(data_value.font.button.font_family_full != 'Defualt'){
          $wc('head').append('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family='+data_value.font.button.font_family+':300,400,500,600,700" type="text/css" />');
          css_changes += '.quickview_product_desc_cls .quickview_fullinfo{font-family:'+data_value.font.button.font_family_full+'; font-size:'+data_value.font.button.font_size+'px; line-height:'+data_value.font.button.line_height+'px;}';
        } else{
          css_changes += '.quickview_product_desc_cls .quickview_fullinfo{font-size:'+data_value.font.button.font_size+'px; line-height:'+data_value.font.button.line_height+'px;}';
        }
        if(data_value.promobar.text.font_family != 'Defualt'){
          $wc('head').append('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family='+data_value.promobar.text.font_family+':300,400,500,600,700" type="text/css" />');
          css_changes += '.wc_quickview_promo_bar p.wc_promo_bar_p{font-size:'+data_value.promobar.text.font_size+'px; color:#'+data_value.promobar.text.color+'; font-family:'+data_value.promobar.text.font_family+';}';
        } else{
          css_changes += '.wc_quickview_promo_bar p.wc_promo_bar_p{font-size:'+data_value.promobar.text.font_size+'px; color:#'+data_value.promobar.text.color+';}';
        }
        if(data_value.promobar.button.text.font_family != 'Defualt'){
          $wc('head').append('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family='+data_value.promobar.button.text.font_family+':300,400,500,600,700" type="text/css" />');
          css_changes += '.wc_quickview_promo_bar .wc_promobar_button{background-color:#'+data_value.promobar.button.bg.color+'; color:#'+data_value.promobar.button.text.color+'; font-size:'+data_value.promobar.button.text.font_size+'px; line-height:'+data_value.promobar.button.text.font_size+'px; font-family:'+data_value.promobar.button.text.font_family+';}';
          css_changes += '.wc_quickview_promo_bar .wc_promobar_button:hover, .wc_quickview_promo_bar .wc_promobar_button:focus{background-color:#'+data_value.promobar.button.bg.hover_color+'; color:#'+data_value.promobar.button.text.hover_color+';}';
        } else{
          css_changes += '.wc_quickview_promo_bar .wc_promobar_button{background-color:#'+data_value.promobar.button.bg.color+'; color:#'+data_value.promobar.button.text.color+'; font-size:'+data_value.promobar.button.text.font_size+'px; line-height:'+data_value.promobar.button.text.font_size+'px;}';
          css_changes += '.wc_quickview_promo_bar .wc_promobar_button:hover, .wc_quickview_promo_bar .wc_promobar_button:focus{background-color:#'+data_value.promobar.button.bg.hover_color+'; color:#'+data_value.promobar.button.text.hover_color+';}';
        }
        css_changes += '</style>';
        $wc(css_changes).insertAfter('#product_quickview_id');
      }
      ajax_success(data_value);
    },
    error: function(XMLHttpRequest, textStatus){
      console.log(XMLHttpRequest);
      wc_error = 'ajax_error';
      ajax_success(data_value);
      showbutton_code();
    }
  });
  
  $wc(document).mouseup(function(e){
    var popup = $wc('#quick_inner_id');
    if(!$wc('.quickview_button_cls_main').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0){
      $wc('#close_quickview_popup').trigger('click');
    }
  });

  $wc('#close_quickview_popup').click(function(){
    $wc('.quickview_outer_padding_cls').addClass('animated '+effect_effect_out);
    setTimeout(function(){
      $wc('.quickview_added_product_cls').hide();
      $wc('#product_quickview_id .quickview_large_img_ul .product_main_img_cls').empty();
      $wc('#product_quickview_id .slider-nav.poplet').empty();
      $wc('#product_quickview_id .product_title a').text('');
      $wc('#product_quickview_id .wc_product_rating_cls').empty();
      $wc('#product_quickview_id .product_title a').attr('href', '');
      $wc('#product_quickview_id .price-part .main').empty();
      $wc('#product_quickview_id .price-part .price-box__new').empty();
      $wc('#product_quickview_id .product-info__description').empty();
      $wc('#product_quickview_id .variants').empty();
      $wc('#product_quickview_id .product-available').hide();
      $wc('#product_quickview_id .product-disable').hide();
      $wc('#product_quickview_id .quickview_error_cls p').empty();
      $wc('#wc_quickview_promo_bar_id .wc_qv_pb_ul').slick('unslick');
      $wc('.quickview_outer_padding_cls').removeClass('animated '+effect_effect_out);
      $wc('#product_quickview_id').hide();
      if(data_value.enable_imgzoom == '1'){
        $wc('.zoomContainer').remove();
      }
    }, 1000);
  });
});

var $ = jQuery.noConflict();